<hunch-input class="search" [inputControl]="searchControl" [placeholder]="'Search for campaign name or ID'" [icon]="'SearchIcon'"
    [svg]="true" [size]="'small'">
</hunch-input>